(function() {
 	'use strict';

 	var 
 		$filtersBtn 				= $("#js-filters-button, .js-open-filters-btn"),
 		$filtersColumn   		= $("#js-filters-column"),
 		$body 							=	$("body"),
 		$closeBtn 					= $("#js-close-filters"),
		$close2Btn 					= $("#js-close2-filters"),
 		$checkboxExpandible = $(".js-checkboxExpandible"),
 		$checkboxExpanded   = $(".js-checkboxExpandible.is-expanded"),
 		isActive 						= false,

 		init = function(){
 			resize();
 		},

 		open = function(){
 			$filtersColumn.addClass("is-visible");
 			isActive = true;
 		},

 		destroy = function(){
 			$filtersColumn.removeClass("is-visible");
 			isActive = false;
 		},

 		resize = function(width){
 			if(width > 769){
	    	$checkboxExpandible.prop('checked', false);
	    } else {
	    	$checkboxExpandible.prop('checked', true);
	    	$checkboxExpanded.prop('checked', false);
	    }
			if(width > 769 && isActive){
	    	destroy();
	    }
	  }

 		$filtersBtn.click(function(e){
 			e.preventDefault();
 			open();
 		});

 		$closeBtn.click(function(e){
 			e.preventDefault();
 			destroy();
 		});
		
		$close2Btn.click(function(e){
 			e.preventDefault();
 			destroy();
 		});

 	if ($filtersColumn.length) {
    init();
    window.resizedCallback.push(resize);
  }

})();